<template>
  <a-modal
      :visible="visible"
      title="手动发放积分"
      width="600px"
      centered
      @ok="handleSubmit"
      @cancel="handleCancel"
  >
    <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <a-form-item label="客户编码">
        <a-textarea
            v-decorator="['customerNos', {
            rules: [
              { required: true, message: '请输入客户编码' },
              { validator: validateCustomerNos }
            ]
          }]"
            placeholder="请输入客户编码，多个客户编码用换行分隔"
            :rows="4"
            auto-size
        />
      </a-form-item>

      <a-form-item label="发放积分">
        <a-input-number
            v-decorator="['points', {
            rules: [
              { required: true, message: '请输入积分数量' },
              { type: 'number', min: 1, message: '积分必须大于0' }
            ]
          }]"
            :min="1"
            :precision="0"
            style="width: 100%"
        />
      </a-form-item>

<!--      <a-form-item label="发放原因">-->
<!--        <a-input-->
<!--            v-decorator="['reason']"-->
<!--            placeholder="请输入发放原因（选填）"-->
<!--        />-->
<!--      </a-form-item>-->
    </a-form>
  </a-modal>
</template>

<script>
import { message } from 'ant-design-vue';
import {manualAddPoints} from "api/points";

export default {
  name: 'ManualGrantPoints',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    ruleId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      form: this.$form.createForm(this)
    };
  },
  methods: {
    // 验证客户编码格式
    validateCustomerNos(rule, value, callback) {
      if (!value || value.trim() === '') {
        callback(new Error('请输入客户编码'));
        return;
      }

      const nos = value.split('\n').filter(no => no.trim() !== '');
      if (nos.length === 0) {
        callback(new Error('请输入至少一个有效的客户编码'));
        return;
      }

      // 检查每个编码是否符合要求
      const valid = nos.every(no => /^[a-zA-Z0-9_-]+$/.test(no.trim()));
      if (!valid) {
        callback(new Error('客户编码只能包含字母、数字、下划线和横线'));
        return;
      }

      callback();
    },

    // 提交表单
    handleSubmit() {
      this.form.validateFields(async (err, values) => {
        if (err) {
          return;
        }
        try {
          // 处理客户编码
          const customerNos = values.customerNos
              .split('\n')
              .map(no => no.trim())
              .filter(no => no !== '');

          const params = {
            ruleId: this.ruleId,
            customerNos,
            points: values.points
          };
          const resp = await manualAddPoints(params);
          if (resp.code === 200) {
            message.success('积分发放成功');
            this.manualGrantVisible = false;
          } else {
            message.error(resp.msg ||  '积分发放失败');
            this.manualGrantVisible = false;
          }
          this.handleCancel();
        } catch (error) {
          console.error('发放积分失败:', error);
          message.error('发放积分失败');
        } finally {
          this.manualGrantVisible = false;
        }
      });
    },

    // 取消
    handleCancel() {
      this.form.resetFields();
      this.$emit('cancel');
    }
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.form.resetFields();
      }
    }
  }
};
</script>

<style scoped>
/* 可以添加组件特定的样式 */
</style>
